<iframe #iframe *ngIf="src" [src]="src" frameborder="0" width="100%" height="100%"></iframe>